jQuery(document).ready(function() {
  jQuery('.product-description-toggle').each(function() {
    const $toggle = jQuery(this);
    const $desc = $toggle.find('.product-short-description');
    const $readMore = $toggle.find('.read-more');
    const $readLess = $toggle.find('.read-less');

    if (!$desc.length) {
      return;
    }

    if ($desc[0].scrollHeight <= $desc[0].clientHeight + 2) {
      $toggle.addClass('is-short');
      $desc.addClass('full');
      return;
    }

    $readMore.on('click', function(event) {
      event.preventDefault();
      $desc.addClass('full');
      $toggle.addClass('is-expanded');
    });

    $readLess.on('click', function(event) {
      event.preventDefault();
      $desc.removeClass('full');
      $toggle.removeClass('is-expanded');
    });
  });
});

if (!customElements.get('product-expert-testimonial-carousel')) {
  class ProductExpertTestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.authorEl = this.querySelector('[data-author-target]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));

      if (this.index < 0) {
        this.index = 0;
      }

      if (this.slides.length <= 1) {
        return;
      }

      this.prevBtn?.addEventListener('click', () => this.go(-1));
      this.nextBtn?.addEventListener('click', () => this.go(1));
      this.render();
    }

    go(delta) {
      const nextIndex = this.index + delta;
      if (nextIndex < 0 || nextIndex >= this.slides.length) {
        return;
      }
      this.index = nextIndex;
      this.render();
    }

    render() {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.hidden = i !== this.index;
      });

      if (this.authorEl) {
        this.authorEl.textContent = this.slides[this.index]?.dataset.slideAuthor || '';
      }

      if (this.prevBtn) {
        this.prevBtn.disabled = this.index === 0;
      }

      if (this.nextBtn) {
        this.nextBtn.disabled = this.index === this.slides.length - 1;
      }
    }
  }

  customElements.define('product-expert-testimonial-carousel', ProductExpertTestimonialCarousel);
}

if (!customElements.get('reviews-featured-carousel')) {
  const FADE_MS = 280;

  class ReviewsFeaturedCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.index = this.slides.findIndex((slide) => !slide.hidden);

      if (this.index < 0) {
        this.index = 0;
      }

      if (this.slides.length <= 1) {
        return;
      }

      this.animating = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayDelay = parseInt(this.dataset.autoplay, 10) || 0;
      this.mobileQuery = window.matchMedia('(max-width: 990px)');
      this.isVisible = false;
      this.timer = null;

      this.prevBtn?.addEventListener('click', () => this.go(-1, true));
      this.nextBtn?.addEventListener('click', () => this.go(1, true));

      this.mobileQuery.addEventListener('change', () => this.syncAutoplay());
      document.addEventListener('visibilitychange', () => this.syncAutoplay());

      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.isVisible = entries[0].isIntersecting;
        this.syncAutoplay();
      }, { threshold: 0.4 });
      this.intersectionObserver.observe(this);

      this.syncAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.intersectionObserver?.disconnect();
    }

    syncAutoplay() {
      const shouldPlay = this.autoplayDelay > 0
        && this.mobileQuery.matches
        && this.isVisible
        && document.visibilityState === 'visible';

      if (shouldPlay) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    }

    startAutoplay() {
      if (this.timer) {
        return;
      }
      this.timer = window.setInterval(() => this.go(1), this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    go(delta, isManual) {
      if (this.animating) {
        return;
      }
      const length = this.slides.length;
      const nextIndex = (this.index + delta + length) % length;

      if (isManual) {
        // A manual nudge shouldn't be immediately followed by an autoplay tick.
        this.stopAutoplay();
        this.syncAutoplay();
      }

      this.transitionTo(nextIndex);
    }

    transitionTo(nextIndex) {
      const current = this.slides[this.index];
      const next = this.slides[nextIndex];
      this.index = nextIndex;

      if (current === next) {
        return;
      }

      if (this.reducedMotion) {
        current.hidden = true;
        next.hidden = false;
        return;
      }

      // Only the text inside each card crossfades — the card box itself
      // (background/border) is swapped instantly, since the two boxes
      // are styled identically and never visibly move or blink.
      const currentBody = current.querySelector('.reviews-featured__card-body');
      const nextBody = next.querySelector('.reviews-featured__card-body');

      this.animating = true;
      currentBody?.classList.add('is-fading-out');

      window.setTimeout(() => {
        current.hidden = true;
        currentBody?.classList.remove('is-fading-out');

        next.hidden = false;
        nextBody?.classList.add('is-fading-out');
        // Force a reflow so the fade-in below is treated as a transition, not a jump-cut.
        if (nextBody) {
          void nextBody.offsetWidth;
        }
        nextBody?.classList.remove('is-fading-out');

        this.animating = false;
      }, FADE_MS);
    }
  }

  customElements.define('reviews-featured-carousel', ReviewsFeaturedCarousel);
}

document.addEventListener('DOMContentLoaded', function() {
  if (!window.matchMedia('(max-width: 767px)').matches) {
    return;
  }

  document.querySelectorAll('.template-product .product-add-to-cart-sticky--inner').forEach(function(inner) {
    inner.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
    });
  });
});
